import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { EditImageComponent } from './edit-image.component';

export type EditableImage = {
  file: File;
};

@Injectable({ providedIn: 'root' })
export class EditImageService {
  constructor(private readonly matDialog: MatDialog) {}

  public editImage(editableImage: EditableImage): Observable<EditableImage | undefined> {
    return this.matDialog
      .open<EditImageComponent, EditableImage, EditableImage>(EditImageComponent, {
        width: '95%',
        height: '95%',
        maxWidth: '95%',
        disableClose: true,

        data: editableImage,
      })
      .afterClosed();
  }
}
